import { css } from '@emotion/react';

import { ThemeTokens } from '../shared/styles';

const { fontWeights, media } = ThemeTokens;

export const headingXl = css`
  letter-spacing: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 48px;
    line-height: 56px;
  }

  ${media.md} {
    font-size: 60px;
    line-height: 72px;
  }
`;

export const headingLg = css`
  letter-spacing: 0;
  font-size: 28px;
  line-height: 32px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 40px;
    line-height: 48px;
  }

  ${media.md} {
    font-size: 48px;
    line-height: 56px;
  }
`;

export const headingMd = css`
  letter-spacing: 0;
  font-size: 24px;
  line-height: 28px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 32px;
    line-height: 40px;
  }

  ${media.md} {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const headingSm = css`
  letter-spacing: 0;
  font-size: 24px;
  line-height: 24px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 28px;
    line-height: 32px;
  }

  ${media.md} {
    font-size: 32px;
    line-height: 40px;
  }
`;

export const headingXs = css`
  letter-spacing: 0;
  font-size: 24px;
  line-height: 28px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 24px;
    line-height: 28px;
  }

  ${media.md} {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const heading2xs = css`
  letter-spacing: 0;
  font-size: 20px;
  line-height: 24px;
  font-weight: ${fontWeights.bolder};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 20px;
    line-height: 24px;
  }

  ${media.md} {
    font-size: 20px;
    line-height: 24px;
  }
`;

// Modifier styles
export const headingUppercase = css`
  text-transform: uppercase;
`;

export const headingBold = css`
  font-weight: 500;
`;

// Font weight styles
export const textNormal = css`
  font-weight: ${fontWeights.normal};
`;

export const textSemibold = css`
  font-weight: ${fontWeights.medium};
`;

export const textBold = css`
  font-weight: ${fontWeights.bold};
`;

export const textExtrabold = css`
  font-weight: ${fontWeights.bolder};
`;

// Text wrap styles
export const wrapPretty = css`
  text-wrap: pretty;
`;

export const wrapBalance = css`
  text-wrap: balance;
`;

export const wrapNowrap = css`
  text-wrap: nowrap;
`;

export const wrapWrap = css`
  text-wrap: wrap;
`;

export const wrapStable = css`
  text-wrap: stable;
`;

// Style mapping object
export const headingSizeStyles = {
  xl: headingXl,
  lg: headingLg,
  md: headingMd,
  sm: headingSm,
  xs: headingXs,
  '2xs': heading2xs,
};

export const textWrapStyles = {
  pretty: wrapPretty,
  balance: wrapBalance,
  nowrap: wrapNowrap,
  wrap: wrapWrap,
  stable: wrapStable,
};

export const textFontWeightStyles = {
  normal: textNormal,
  semibold: textSemibold,
  bold: textBold,
  extrabold: textExtrabold,
};
